"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authReferralContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("../player/models");
const promo_1 = require("../promo");
const c = (0, core_1.initContract)();
exports.authReferralContract = c.router({
    getInvitees: {
        method: 'GET',
        path: '/invitees',
        responses: {
            200: models_1.ZPlayerSelectPrivate.pick({
                id: true,
                firstName: true,
                avatarLocation: true,
            })
                .extend({
                isEligibleForRewards: zod_1.z.boolean(),
                gracePeriodHoursRemaining: zod_1.z.number().nullable(),
            })
                .array(),
            400: c.type(),
        },
    },
    getInviters: {
        method: 'GET',
        path: '/inviters',
        responses: {
            200: models_1.ZPlayerSelectPrivate.pick({
                id: true,
                firstName: true,
                avatarLocation: true,
            })
                .extend({
                isEligibleForRewards: zod_1.z.boolean(),
                gracePeriodHoursRemaining: zod_1.z.number().nullable(),
            })
                .array(),
            400: c.type(),
        },
    },
    getSharedWins: {
        method: 'GET',
        path: '/shared-wins',
        responses: {
            200: zod_1.z.object({
                received: promo_1.ZPromoPrizeRewardSelect.pick({
                    createdAt: true,
                    expiresAt: true,
                    status: true,
                })
                    .extend({
                    createdAt: zod_1.z.coerce.date(),
                    promoPrizeRewardId: zod_1.z.string(),
                    promoPrizeOfferCode: zod_1.z.string(),
                    prizeSlug: zod_1.z.string(),
                    prizeTitle: zod_1.z.string(),
                    friendFirstName: zod_1.z.string(),
                    friendPrizeTierCode: zod_1.z.string(),
                })
                    .array(),
                sent: zod_1.z
                    .object({
                    prizeWinId: zod_1.z.string(),
                    createdAt: zod_1.z.coerce.date(),
                    prizeTierCode: zod_1.z.string(),
                    friendFirstNames: zod_1.z.string().array(),
                    friendPromoPrizeOfferCode: zod_1.z.string(),
                    friendPrizeSlug: zod_1.z.string(),
                    friendPrizeTitle: zod_1.z.string(),
                })
                    .array(),
            }),
            400: c.type(),
        },
    },
    getSharedWinStats: {
        method: 'GET',
        path: '/shared-win-stats',
        responses: {
            200: zod_1.z.object({
                received: zod_1.z.number(),
                sent: zod_1.z.number(),
            }),
            400: c.type(),
        },
    },
}, {
    pathPrefix: '/auth',
    commonResponses: {
        401: c.type(),
    },
});
//# sourceMappingURL=referral.auth.contract.js.map